import React from 'react';

import { CanvasPolygons } from '@paragon/client-tools';
import { Polygon2D } from '@paragon/geometry-library';

interface Props {
  polygon: Polygon2D;

  color: string;

  maxWidth: number;
  maxHeight: number;
}

export const PolygonPreview = ({ polygon, color, maxWidth, maxHeight }: Props) => (
  <CanvasPolygons shapes={[polygon.vertices]} color={color} maxWidth={maxWidth} maxHeight={maxHeight} />
);
